import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UserActions from "../../store/ducks/user";
import "./HeaderBJ.style.css";
import {headerScript} from "../../assets/js/header"
import $ from 'jquery';

class Header extends Component {
    constructor(props){
      super(props);
      this.state = {
        menuOpen: false,
        loadingHeader: true,
      }
      let baseUriHome = window._env_.API_HOME_ISTOE;	    
      fetch(baseUriHome).then( async response => {
        let resp = await response.json();

        resp.styles.map((style) => {
          console.log(style.indexOf('bootstrap-css-css'))
          if(style.indexOf('bootstrap-css-css') === -1){
            $('head').prepend(style);
          }
        })
        
        this.refs.headerRef.innerHTML = resp.header;
        this.setState({loadingHeader: false})
        const menu = await $('.icon-menu')
        const { match, location, history } = this.props;
        
        $('.cabecalho',this.refs.headerRef).addClass("container");
        this.refs.sidebarRef.innerHTML = resp.sidebar;
        $('a',this.refs.headerRef).each(function() {
          let $t = $(this);
          $t.attr("name", $t.attr('href')).removeAttr('href');
        });
        $('img',this.refs.headerRef).each(function() {
          let $t = $(this);
          $t.attr("src", $t.attr('data-src')).removeAttr('data-src');
        });
        $('a',this.refs.sidebarRef).each(function() {
          let $t = $(this);
          if($t.attr('href') !== 'https://istoe.com.br/podcasts/'){
            $t.attr("name", $t.attr('href')).removeAttr('href');
          } else {
            $t.removeAttr('target');
          }
        });
        $("a",this.refs.headerRef).on('click', function(){
          if(!$(this).hasClass('icon-menu')){
            let link = $(this).attr("name");
            if($(this).hasClass('icone-de-busca2')){
              link = `https://istoe.com.br${link}`;
            }
            
            localStorage.setItem("getUrl", link);
            history.push('/site');
          }
        })
        $("a",this.refs.sidebarRef).on('click', async function(){
          let link = $(this).attr("name");
          if(link == '/podcasts/'){
            //window.location = link;
            history.push('/');
            await $('.sidebar-100, .shadow-new').toggleClass('active');
          } else {
            localStorage.setItem("getUrl", link);
            history.push('/site');
          }
        })

        //console.log(menu)
        $(menu).on('click',await function(){
          //$('.shadow-new').toggle();
          $('.sidebar-100, .shadow-new').toggleClass('active')
        })
        $('.sidebar-100, .shadow-new').on('click',await function(){
          //$('.shadow-new').toggle()
          $('.sidebar-100, .shadow-new').toggleClass('active')
        })
      });
    }

    /* 
    * Aplicação do clima tempo
    */
    
  getStoredFinancialData() {
    const cachedData = localStorage.getItem('financialData');
    const cachedTimestamp = localStorage.getItem('financialDataTimestamp');

    if (cachedData && cachedTimestamp) {
      const now = new Date().getTime();
      const age = now - parseInt(cachedTimestamp);

      // Defina um limite de tempo para o cache financeiro (por exemplo, 5 minutos em milissegundos)
      const cacheTimeLimit = 5 * 60 * 1000; // 5 minutos em milissegundos

      if (age < cacheTimeLimit) {
        return JSON.parse(cachedData);
      }
    }
    return null;
  }

  storeFinancialData(data) {
    localStorage.setItem('financialData', JSON.stringify(data));
    localStorage.setItem('financialDataTimestamp', new Date().getTime().toString());
  }

  insertInHtml(json) {
    const nameCity = document.getElementById('name-city');
    if(nameCity)
      nameCity.innerHTML = json.results.city_name;

    const graus = document.getElementById('graus');
    if(graus)
      graus.innerHTML = json.results.temp + '°';

    const description = document.getElementById('description');
    if(description)
      description.innerHTML = json.results.description;

    const climateDesc =document.getElementById('climate-desc');
    if(climateDesc)
      climateDesc.innerHTML = `<img src="https://istoe.com.br/wp-content/themes/project_theme/assets/img/widgetClimaDolar/${json.results.condition_slug}.png?x25148" alt="${json.results.condition_slug}">`;
  }

  getStoredWeatherData() {
    const cachedData = localStorage.getItem('weatherData');
    const cachedTimestamp = localStorage.getItem('weatherDataTimestamp');

    if (cachedData && cachedTimestamp) {
      const now = new Date().getTime();
      const age = now - parseInt(cachedTimestamp);

      // 7200000 milissegundos = 2 horas
      const cacheTimeLimit = 2 * 60 * 60 * 1000; // 2 horas em milissegundos

      if (age < cacheTimeLimit) {
        return JSON.parse(cachedData);
      }
    }
    return null;
  }

  storeWeatherData(data) {
    localStorage.setItem('weatherData', JSON.stringify(data));
    localStorage.setItem('weatherDataTimestamp', new Date().getTime().toString());
  }

  searchClimate(latitude, longitude) {
    const baseUrl = `https://api.hgbrasil.com/weather?format=json-cors&key=808df7c6&lat=${latitude}&lon=${longitude}&user_ip=remote`;

    const cachedData = this.getStoredWeatherData();
    if (cachedData) {
      this.insertInHtml(cachedData);
      return;
    }

    fetch(baseUrl)
    .then(res => res.json())
    .then(json => {
      this.storeWeatherData(json);
      this.insertInHtml(json);
    })
    .catch(err => console.log('Problema ao buscar dados meteorológicos:', err));
  }

  displayFinancialData(data) {

    console.log("Data Finance", data);
    let ibovespaVariation = data.stocks.IBOVESPA.variation;
    let dolarBuy = data.currencies.USD.buy;

    // Convertendo e formatando os valores
    let ibovespaVariationStr = ibovespaVariation.toString().replace('.', ',');
    const dolarRounded = Math.round(dolarBuy * 1000) / 1000;
    const dolarBuyStr = dolarRounded.toString().replace('.', ',');

    // Verifica se a variação é positiva ou negativa
    const ibovespaStatus = ibovespaVariation > 0 ? 'positiva' : 'negativa';
    const dolarStatus = data.currencies.USD.variation > 0 ? 'positiva' : 'negativa';

    // Exibe as informações com o status de variação
    const ibovespaVElement = this.refs.headerRef.querySelector('#IbovespaV');
    ibovespaVElement.innerHTML = `<h3>Ibovespa</h3> <span class="${ibovespaStatus}">${ibovespaVariationStr}%</span>`;
  
    const dolarVElement = this.refs.headerRef.querySelector('#DolarV');
    dolarVElement.innerHTML = `<h3>Dólar</h3> <span class="${dolarStatus}">R$ ${dolarBuyStr}</span>`;  
  }

  
    
    componentDidUpdate(prevProps, prevState){
      console.log(prevState, this.state)
      if(!this.state.loadingHeader){
        // Verificar se a geolocalização está disponível no navegador
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            position => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;
              this.searchClimate(latitude, longitude); // Atualizar com a localização do usuário
            },
            error => {
              console.log('Permissão de geolocalização negada ou indisponível. Usando coordenadas padrão.');
              this.searchClimate(-23.550520, -46.633308); // Carregar informações de São Paulo Capital
            }
          );
        } else {
          console.log('Geolocalização indisponível. Usando coordenadas padrão.');
          this.searchClimate(-23.550520, -46.633308); // Carregar informações de São Paulo Capital
        }
        
        // Verificar se há dados financeiros em cache
        const cachedFinancialData = this.getStoredFinancialData();

        if (cachedFinancialData) {
          // Usar os dados financeiros em cache
          this.displayFinancialData(cachedFinancialData);
        } else {
          // Fazer uma solicitação à API para obter os dados financeiros
          fetch(process.env.REACT_APP_API_FINANCE)
          .then(response => response.json())
          .then(data => {
              this.displayFinancialData(data);
              this.storeFinancialData(data);
          })
          .catch(err => console.log('Problema ao buscar dados financeiros:', err));
        }
      }
    }
    render() {
        // console.log("LocalStorage: ",localStorage);
        return (
          <>
            {/* headerbrj */}
            <header className="header-istoe" ref="headerRef">
            </header>
            <div className="shadow-new"></div>
            <div ref="sidebarRef"></div>
            {/* !headerbrj */}
          </>
        )
    }
}
function mapStateToProps({ user }) {
    return { user };
  }
  
  const mapDistapchToProps = dispatch =>
    bindActionCreators({ ...UserActions }, dispatch);
  
  export default withRouter(connect(
    mapStateToProps,
    mapDistapchToProps
  )(Header));
